import type { PlatformPos } from "@/platform/types";

/**
 * AC-E (trd-client#338): la app no se actualiza mientras haya ventas de la caja
 * en pendiente o enviando, de cualquier negocio del equipo: una versión nueva
 * podría no leer su formato. Lo que necesita atención no la frena; si la
 * frenara, un bug de la caja no se podría arreglar con una versión nueva.
 *
 * Si el almacén no se puede leer, no hay cola que proteger: la actualización
 * sigue (y puede ser justo la que lo arregla).
 */
export async function puedeActualizar(
  pos: Pick<PlatformPos, "isAvailable" | "updateBlocked">
): Promise<boolean> {
  if (!pos.isAvailable) return true;
  try {
    return !(await pos.updateBlocked());
  } catch {
    return true;
  }
}

export const MENSAJE_ACTUALIZACION_EN_ESPERA =
  "Hay ventas de la caja sin subir: la actualización espera a que se suban.";
